import SEOHead from '../../components/base/SEOHead';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Mission from './components/Mission';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Founders from './components/Founders';
import Footer from './components/Footer';

export default function HomePage() {
  const baseUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "KaliKare Homecare",
      "image": `${baseUrl}/og-image.jpg`,
      "logo": "https://kalikarehomecare.com/wp-content/uploads/2020/05/ik.jpg",
      "description": "KaliKare provides compassionate, quality one-on-one home care services in Radnor, PA and surrounding areas. Our dedicated caregivers deliver personalized personal care, companion care, and specialized dementia care.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "201 King of Prussia Rd, Suite 650",
        "addressLocality": "Radnor",
        "addressRegion": "PA",
        "postalCode": "19087",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "40.0459",
        "longitude": "-75.3771"
      },
      "telephone": "+1-833-438-5542",
      "email": "info@kalikarehomecare.com",
      "url": baseUrl,
      "priceRange": "$$",
      "sameAs": [],
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "18:00"
        }
      ],
      "areaServed": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "40.0459",
          "longitude": "-75.3771"
        },
        "geoRadius": "50000"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Home Care Services",
        "itemListElement": [
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Personal Care" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Companion Care" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Dementia & Alzheimer\u2019s Care" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Respite Care" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "24/7 Live-In Care" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Post-Hospitalization Care" } }
        ]
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "KaliKare Homecare",
      "url": baseUrl,
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${baseUrl}/services?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What home care services does KaliKare Homecare offer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KaliKare Homecare offers personal care, companion care, dementia and Alzheimer\u2019s care, respite care, 24/7 live-in care, and post-hospitalization care in Radnor, PA and surrounding areas."
          }
        },
        {
          "@type": "Question",
          "name": "Where is KaliKare Homecare located?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KaliKare Homecare is located at 201 King of Prussia Rd, Suite 650, Radnor, PA 19087."
          }
        },
        {
          "@type": "Question",
          "name": "How can I contact KaliKare Homecare?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can reach KaliKare Homecare by calling 833-438-5542 or emailing info@kalikarehomecare.com."
          }
        },
        {
          "@type": "Question",
          "name": "Does KaliKare Homecare provide 24/7 care?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, KaliKare Homecare offers 24/7 live-in care to ensure your loved one receives round-the-clock support and companionship in the comfort of their own home."
          }
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="KaliKare Homecare – Quality Home Care Services in Radnor, PA"
        description="KaliKare Homecare provides quality one-on-one home care services in Radnor, PA and surrounding areas. Our dedicated caregivers deliver personalized personal care, companion care, and specialized dementia care to help your loved ones live safely and comfortably at home."
        canonical="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <Hero />
      <Mission />
      <Services />
      <WhyChooseUs />
      <Founders />
      <Footer />
    </div>
  );
}
